import { runStatus } from "../../MethodNavigation";
/** One small square for each run, oldest on the left: green completed, red failed, blue running. Empty slots are grey. */
export function RunSquares({ statuses, slots = 10, size = "row" }: { statuses: string[]; slots?: number; size?: "row" | "mark" }) {
  const cells = [...Array(Math.max(0, slots - statuses.length)).fill("empty"), ...statuses.slice(-slots)];
  return <span className={`run-squares run-squares-${size}`} aria-label={`Last ${statuses.length} runs`}>
    {cells.map((status, index) => <i key={index} className={`run-square ${squareClass(status)}`} title={status === "empty" ? undefined : runStatus(status).label} />)}
  </span>;
}
export function squareClass(status: string) {
  if (status === "empty") return "is-empty";
  if (status === "succeeded") return "is-done";
  if (status === "running" || status === "queued") return "is-running";
  if (status === "waiting" || status === "waiting_for_you" || status === "unconfirmed") return "is-waiting";
  if (status === "disconnected" || status === "cancelled") return "is-quiet";
  return "is-attention";
}

/** A thin bar with one mark per run, for a group of many runs. */
export function RunBar({ statuses }: { statuses: string[] }) {
  return <span className="run-bar" aria-label={`${statuses.length} runs`}>{statuses.map((status, index) => <i key={index} className={squareClass(status)} />)}</span>;
}
